import { api } from "@/lib/server";
import { recordTrackedEvent } from "@/lib/kiosk-session-tracking";

/** Validates a coupon code with the backend and, when it is valid, stores it
 * for the session so the next payment is created with the discount. */
export async function applyCouponCode({
  code,
  machineId,
  dryerBundleId,
  source,
}: {
  code: string;
  machineId?: number;
  dryerBundleId?: number;
  /** Whether the code was typed in or tapped in the "my coupons" list. */
  source: "manual" | "my-coupons";
}) {
  const response = await api.applyCoupon({
    couponKey: code,
    ...(machineId ? { machineId } : {}),
    ...(dryerBundleId ? { dryerBundleId } : {}),
  });

  if (response.type === "success" && response.data) {
    const data = response.data;
    sessionStorage.setItem("coupon", JSON.stringify({ ...data, code }));
    void recordTrackedEvent({
      eventType: "coupon_applied",
      machineId,
      dryerBundleId,
      couponNonceKey: data.couponKey ?? undefined,
      payload: {
        couponCode: code,
        fixDiscount: data.fixDiscount,
        percentage: data.percentage,
        source,
      },
    });
  }

  return response;
}
